export const GET_ORDERS = "GET_ORDERS";
export const FILTER_ORDERS = "FILTER_ORDERS";
export const GET_DATA_QUALITY_SAP_ORDERS = "GET_DATA_QUALITY_SAP_ORDERS";
export const GET_DATA_QUALITY_SAP_ORDERS_BULK =
  "GET_DATA_QUALITY_SAP_ORDERS_BULK";
export const GET_HWS_SNS_TRAIL = "GET_HWS_SNS_TRAIL";
export const GET_HWS_SNS_TRAIL_BULK = "GET_HWS_SNS_TRAIL_BULK";
export const FILTER_DATA_QUALITY_SAP_ORDERS = "FILTER_DATA_QUALITY_SAP_ORDERS";
export const FILTER_HWS_SNS_TRAIL = "FILTER_DHWS_SNS_TRAIL";
export const FILTER_SERIAL_NUMBERS = "FILTER_SERIAL_NUMBERS";
export const GET_SERIAL_NUMBERS = "GET_SERIAL_NUMBERS";
export const SORT_SERIAL_NUMBERS = "SORT_SERIAL_NUMBERS";
export const SORT_ORDERS = "SORT_ORDERS";
export const SORT_DATA_QUALITY_SAP_ORDERS = "SORT_DATA_QUALITY_SAP_ORDERS";
export const SORT_HWS_SNS_TRAIL = "SORT_HWS_SNS_TRAIL";
export const CALL_MATERIAL_SWAP = "CALL_MATERIAL_SWAP";
export const CALL_HWS_SWAP = "CALL_HWS_SWAP";
export const CHECK_HWS_SWAP = "CHECK_HWS_SWAP";
export const CLEAN_API_RESPONSE = "CLEAN_API_RESPONSE";
export const ADD_HWS_SNS_TRAIL_OUT = "ADD_HWS_SNS_TRAIL_OUT";
export const GET_BULK_REPORT = "GET_BULK_REPORT";
export const SORT_BULK_EXPORT = "SORT_BULK_EXPORT";
export const FILTER_BULK_REPORT = "FILTER_BULK_REPORT";
export const GET_MISSING_SNS_STATUS = "GET_MISSING_SNS_STATUS";
export const GET_MISSING_SNS_STATUS_BULK = "GET_MISSING_SNS_STATUS_BULK";
export const SORT_MISSING_SNS_STATUS = "SORT_MISSING_SNS_STATUS";
export const FILTER_MISSING_SNS_STATUS = "FILTER_MISSING_SNS_STATUS";

export function filterOrders(filterParameters) {
  console.log("Action FILTER_ORDERS", filterParameters);
  return { type: FILTER_ORDERS, data: filterParameters };
}

export function getOrders(queryParameters) {
  console.log("Action GET_ORDERS", queryParameters);
  queryParameters.limit = 100;
  return { type: GET_ORDERS, data: queryParameters };
}

export function getHwsSnTrail(queryParameters) {
  console.log("Action GET_HWS_SNS_TRAIL", queryParameters);
  queryParameters.limit = 100;
  return { type: GET_HWS_SNS_TRAIL, data: queryParameters };
}

export function getHwsSnTrailsBulk(queryParameters) {
  console.log("Action GET_HWS_SNS_TRAIL_BULK", queryParameters);
  return { type: GET_HWS_SNS_TRAIL_BULK, data: queryParameters };
}

export function filterHwsSnTrail(filterParameters) {
  console.log("Action FILTER_HWS_SNS_TRAIL", filterParameters);
  return { type: FILTER_HWS_SNS_TRAIL, data: filterParameters };
}

export function sortHwsSnTrail(sortParameter, direction) {
  console.log("Action SORT_HWS_SNS_TRAIL");
  return { type: SORT_HWS_SNS_TRAIL, data: { sortParameter, direction } };
}

export function filterDataQualitySapOrders(filterParameters) {
  console.log("Action FILTER_DATA_QUALITY_SAP_ORDERS", filterParameters);
  return { type: FILTER_DATA_QUALITY_SAP_ORDERS, data: filterParameters };
}

export function getDataQualitySapOrders(queryParameters) {
  console.log("Action GET_DATA_QUALITY_SAP_ORDERS", queryParameters);
  return { type: GET_DATA_QUALITY_SAP_ORDERS, data: queryParameters };
}

export function getMissingSnsStatusBulk(queryParameters) {
  console.log("Action GET_MISSING_SNS_STATUS_BULK", queryParameters);
  return { type: GET_MISSING_SNS_STATUS_BULK, data: queryParameters };
}

export function getMissingSnsStatus(queryParameters) {
  console.log("Action GET_MISSING_SNS_STATUS", queryParameters);
  return { type: GET_MISSING_SNS_STATUS, data: queryParameters };
}

export function getDataQualitySapOrdersBulk(queryParameters) {
  console.log("Action GET_DATA_QUALITY_SAP_ORDERS_BULK", queryParameters);
  return { type: GET_DATA_QUALITY_SAP_ORDERS_BULK, data: queryParameters };
}

export function sortSerialNumbers(sortParameter, direction) {
  console.log("Action SORT_SERIAL_NUMBERS");
  return { type: SORT_SERIAL_NUMBERS, data: { sortParameter, direction } };
}

export function sortOrders(sortParameter, direction) {
  console.log("Action SORT_ORDERS");
  return { type: SORT_ORDERS, data: { sortParameter, direction } };
}

export function sortDataQualitySapOrders(sortParameter, direction) {
  console.log("Action SORT_DATA_QUALITY_SAP_ORDERS");
  return {
    type: SORT_DATA_QUALITY_SAP_ORDERS,
    data: { sortParameter, direction },
  };
}
export function sortMissingSnsStatus(sortParameter, direction) {
  console.log("Action SORT_MISSING_SNS_STATUS");
  return { type: SORT_MISSING_SNS_STATUS, data: { sortParameter, direction } };
}

export function filterMissingSnsStatus(filterParameters) {
  console.log("Action FILTER_MISSING_SNS_STATUS", filterParameters);
  return { type: FILTER_MISSING_SNS_STATUS, data: filterParameters };
}
export function getSerialNumbers(queryParameters) {
  console.log("Action GET_SERIAL_NUMBERS", queryParameters);
  return { type: GET_SERIAL_NUMBERS, data: queryParameters };
}

export function filterSerialNumbers(filterParameters) {
  console.log("Action FILTER_SERIAL_NUMBERS", filterParameters);
  return { type: FILTER_SERIAL_NUMBERS, data: filterParameters };
}

export function callMaterialSwap(materialSwapSns) {
  console.log("Action CALL_MATERIAL_SWAP", materialSwapSns);
  return { type: CALL_MATERIAL_SWAP, materialSwapSns };
}

export function callHwsSwap(hwsSwapSns) {
  console.log("Action CALL_HWS_SWAP", hwsSwapSns);
  return { type: CALL_HWS_SWAP, hwsSwapSns };
}

export function checkHwsSwap(hwsSwapSns) {
  console.log("Action CHECK_HWS_SWAP", hwsSwapSns);
  return { type: CHECK_HWS_SWAP, hwsSwapSns };
}

export function cleanApiResponse() {
  console.log("Action CLEAN_API_RESPONSE");
  return { type: CLEAN_API_RESPONSE };
}
export function addHwsSnsTrailOut(hwsSnTrailOut) {
  console.log("Action ADD_HWS_SNS_TRAIL_OUT");
  return { type: ADD_HWS_SNS_TRAIL_OUT, hwsSnTrailOut };
}

export function getBulkReport(parameter) {
  console.log("Action GET_BULK_REPORT", parameter);
  return { type: GET_BULK_REPORT, data: parameter };
}

export function sortBulkExports(sortParameter, direction) {
  console.log("Action SORT_BULK_EXPORT", sortParameter, direction);
  return { type: SORT_BULK_EXPORT, data: { sortParameter, direction } };
}

export function filterBulkReport(filterObject) {
  console.log("Action FILTER_BULK_REPORT", filterObject);
  return { type: FILTER_BULK_REPORT, data: filterObject };
}
